import { useMutation } from "@tanstack/react-query";

import http from "../../../http";
import { GET_EFM_TRANSACTIONS } from "../../URL";
import { IAxisErrorResponse } from "../../../interfaces";

interface IPaymentAccount {
  paymentAccountID: string;
  accountName: string;
  paymentAccountTypeCode: string;
  efmFilingId: string;
}

interface IFilter {
  startDate?: string;
  endDate?: string;
  efmFilingStatus?: string;
  location?: string;
  efmEnvelopeId?: string;
  userId: string;
  efmUserId: string;
  efmFirmId?: string;
  isFirmAdmin?: string;
  filingFilter: string;
  isPendingCount: boolean;
  showTransactionForDashboard: boolean;
}

const getEFMTransactions = async (filters: IFilter) => {
  const response = await http.post<IPaymentAccount[]>(
    GET_EFM_TRANSACTIONS,
    filters
  );

  return response.data.map((transaction) => ({
    ...transaction,
    uniqueId: transaction.efmFilingId + Math.random(),
  }));
};

const useEFMTransactions = () =>
  useMutation<IPaymentAccount[], IAxisErrorResponse, IFilter>({
    mutationKey: ["efm-transactions"],
    mutationFn: getEFMTransactions,
  });

export default useEFMTransactions;
